import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper, Typography } from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { AppContext } from '../../context/AppContext';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import * as Button from '../../components/buttons/BakeasyButtons';
import { BakeasyChipDelete } from '../../components/common/BakeasyChip';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import {
  categoryState,
  clearCategoryState,
  fetchCategories,
} from '../../redux_store/slices/categorySlice';
import {
  clearSubCategoryState,
  fetchSubCategories,
  subCategoryState,
} from '../../redux_store/slices/subCategorySlice';
import { clearCreateOrdersState } from '../../redux_store/slices/createOrdersSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import dayjs, { Dayjs } from 'dayjs';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import {
  BakeasyAutoCompleteCategoryA,
  BakeasyAutoCompleteProduct,
  BakeasyAutoCompleteSubCategoryA,
} from '../../components/dropdowns/BakeasyAutoComplete';
import {
  clearProductState,
  fetchProducts,
  productsState,
} from '../../redux_store/slices/productsSlice';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import {
  clearDraftOrdersState,
  deleteDraftOrderById,
  draftorders,
  draftOrderState,
  fetchdraftOrders,
} from '../../redux_store/slices/draftOrdersSlice';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { supplierState } from '../../redux_store/slices/supplierSlice';
import {
  fetchOrderHistoryById,
  OrderHistoryState,
} from '../../redux_store/slices/OrderHistorySlice';
import { createOrderProductTableHeaders } from '../../constants/TableHeaders';
import { validateField } from '../../utils/ValidationUtils';
import * as Regex from '../../constants/Regex';
import { getCurrency } from '../../utils/commonUtils';
import { storeState } from '../../redux_store/slices/storeSlice';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export const CreateOrder = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [ordersList, setOrdersList] = useState<any[]>(
    state?.selectedOrders?.length ? state.selectedOrders : []
  );
  const [productName, setProductName] = useState<any>('');
  const [price, setPrice] = useState<any>();
  const [note, setNote] = useState('');
  const [quantity, setQuantity] = useState<any>(0);
  const [selectedCategory, setSelectedCategory] = useState<any>(undefined);
  const [subCategoryOptions, setSubCategoryOptions] = useState<any[]>([]);
  const [selectedSubCategory, setSelectedSubCategory] =
    useState<any>(undefined);
  const [selectedProduct, setSelectedProduct] = useState<any>(undefined);
  let _categoryState = useAppSelector(categoryState);
  let _subCategoryState = useAppSelector(subCategoryState);
  let _productsState = useAppSelector(productsState);
  let _draftOrders: any = useAppSelector(draftOrderState);
  let _supplierState: any = useAppSelector(supplierState);
  let _orderHistoryState = useAppSelector(OrderHistoryState);
  const [totalPrice, setTotalPrice] = useState(0);
  const [orderBy, setorderBy] = useState('');
  const [id, setID] = useState<any>('');
  const [poNumber, setPoNumber] = useState<any>();
  const [requestedDeliveryDate, setRequestedDeliveryDate] =
    useState<Dayjs | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<any>('No');

  let _storeState = useAppSelector(storeState);

  useEffect(() => {
    dispatch(fetchProducts({ page: 1, limit: 10 }));
  }, []);

  useEffect(() => {
    if (state?.from === 'DuplicateClick' && _orderHistoryState?.selectedValue) {
      setData(_orderHistoryState?.selectedValue);
      setPoNumber('');
      setRequestedDeliveryDate(null);
    }
  }, [_orderHistoryState?.selectedValue]);

  // useEffect(() => {
  //   if (_subCategoryState?.value?.data?.length === 0 && selectedCategory) {
  //     dispatch(showErrorSnackbar({ message: t('SUB_CATEGORY_NOT_FOUND') }));
  //   }
  // }, [_subCategoryState]);

  // useEffect(() => {
  //   if (_productsState?.value?.data?.length === 0 && selectedCategory && selectedSubCategory) {
  //     dispatch(showErrorSnackbar({ message: t('PRODUCT_NOT_FOUND') }));
  //   }
  // }, [_productsState]);

  useEffect(() => {
    switch (state?.from) {
      case 'CartClick':
        setData(_draftOrders?.value.data[0]);
        break;
      case 'DuplicateClick':
        dispatch(fetchOrderHistoryById({ id: state?._id }));
        break;
    }
  }, [state?.from]);

  useEffect(() => {
    if (ordersList.length > 0) {
      const orders = ordersList.map((item) => {
        if (item?.productChecked) {
          item.unitPrice = item?.price;
          item.totalprice = (
            Number(item?.quantity) * Number(item?.price)
          ).toFixed(2);
          item.actions = [
            <BakeasyChipDelete
              onClick={(event: any) => {
                event.stopPropagation();
                openDeleteConfirmDialog(item.productId);
              }}
            />,
          ];
        }
        return item;
      });

      setOrdersList(orders);
    }
  }, [state.selectedOrders]);

  async function handleCategorySelect(category: any) {
    setSelectedSubCategory(undefined);
    dispatch(clearProductState());
    if (category === undefined || category === null) {
      setSelectedCategory(undefined);
      return;
    }

    setSelectedCategory(category);
    await dispatch(
      fetchSubCategories({ page: 1, limit: 10, categoryId: category?._id })
    );

    await dispatch(
      fetchProducts({
        page: 1,
        limit: 10,
        ...(category?._id && { categoryId: category?._id }),
        ...(selectedSubCategory?._id && {
          subCategoryId: selectedSubCategory?._id,
        }),
      })
    );
  }

  async function handleSubCategorySelect(subCategory: any) {
    setSelectedProduct(undefined);
    if (subCategory === undefined || subCategory === null) {
      setSelectedProduct(undefined);
      return;
    }

    setSelectedSubCategory(subCategory);

    await dispatch(
      fetchProducts({
        page: 1,
        limit: 10,
        ...(selectedCategory?._id && { categoryId: selectedCategory?._id }),
        ...(subCategory?._id && { subCategoryId: subCategory?._id }),
      })
    );
  }

  async function handleProductSelect(product: any) {
    setSelectedProduct(product);
    setPrice(product?.storeCost);

    if (product) {
      if (product?.categoryName) {
        setSelectedCategory({
          _id: product?.categoryId,
          categoryId: product?.categoryId,
          categoryName: product?.categoryName,
        });
      }

      if (product?.subCategoryName) {
        setSelectedSubCategory({
          _id: product?.categoryId,
          subCategoryId: product?.subCategoryId,
          subCategoryName: product?.subCategoryName,
        });
      }
    } else {
      setSelectedCategory(undefined);
      setSelectedSubCategory(undefined);
    }
  }

  useEffect(() => {
    dispatch(clearCategoryState());
    dispatch(clearSubCategoryState());
    dispatch(fetchCategories({ page: 1, limit: 10 }));
  }, [ordersList]);

  const handleDeleteRow = (productId: any) => {
    setOrdersList((prevOrdersList) => {
      const index = prevOrdersList.findIndex(
        (order) => order.productId === productId
      );
      if (index !== -1) {
        const updatedList = [...prevOrdersList];
        updatedList.splice(index, 1);
        //autoSaveOrderToCart(updatedList);
        return updatedList;
      } else {
        return prevOrdersList;
      }
    });
  };

  const handleClearForm = () => {
    setSelectedCategory('');
    setSelectedSubCategory('');
    setProductName('');
    setQuantity('');
    setPrice('');
  };

  const openDeleteConfirmDialog = (productId: any) => {
    myContext.setConfirmDialog({
      open: true,
      title: t('CONFIRMATION'),
      message: t('DELETE_PRODUCT_FROM_ORDER_CONFIRMATION'),
      onYesClick: (event: any) => {
        handleDeleteRow(productId);
      },
    });
  };

  function openNewOrderSummaryDialog(isEdit: any, data: any) {
    return myContext.setDialog({
      open: true,
      title: 'NEW_ORDER_SUMMARY',
      dialogContent: {
        pageName: 'NewOrderSummary',
        params: { isEdit, data, isDraftOrder: state?.from === 'CartClick' },
        onBack: async () => {},
      },
    });
  }

  const handleAddButtonClick = async () => {
    // if (!selectedProduct || !quantity || !price) {
    //   dispatch(showErrorSnackbar({ message: 'Please fill in all fields before adding the order' }));
    //   return;
    // }
    if (!validateField(dispatch, 'PRODUCT_NAME', selectedProduct)) {
      return false;
    }
    if (
      !validateField(dispatch, 'QUANTITY_PER_UNIT', quantity, Regex.quantity)
    ) {
      return false;
    }

    if (!validateField(dispatch, 'COST_PRICE', price)) {
      return false;
    }
    if (price <= 0) {
      dispatch(
        showErrorSnackbar({ message: t('PRICE_MUST_BE_GREATER_THAN_ZERO') })
      );
      return;
    }
    if (quantity <= 0) {
      dispatch(
        showErrorSnackbar({ message: t('QUANTITY_MUST_BE_GREATER_THAN_ZERO') })
      );
      return;
    }

    const totalPrice = (Number(quantity) * Number(price)).toFixed(2);
    const _newOrderId = ordersList?.length + 1;

    const newOrder = {
      id: _newOrderId,
      productId: selectedProduct.productId,
      userProductId: selectedProduct?.userProductId,
      product_id: selectedProduct.product_id,
      categoryId: selectedCategory?._id,
      subCategoryId: selectedSubCategory?._id,
      productName: selectedProduct?.productName,
      quantity: Number(quantity),
      unitPrice: Number(price),
      totalprice: totalPrice,
      actions: [
        <BakeasyChipDelete
          onClick={(event: any) => {
            event.stopPropagation();
            openDeleteConfirmDialog(selectedProduct.productId);
          }}
        />,
      ],
    };

    setOrdersList([...ordersList, newOrder]);
    setSelectedCategory(undefined);
    setSelectedSubCategory(undefined);
    setSelectedProduct(undefined);
    setProductName('');
    setQuantity(0);
    setPrice(0);

    //await autoSaveOrderToCart([...ordersList, newOrder]);
  };

  const checkValidity = (): boolean => {
    // if (!orderBy) {
    //   let msg = `${t('ORDER_BY')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (!validateField(dispatch, 'ORDER_BY', orderBy)) {
      return false;
    }
    // if (!validateField(dispatch, 'STORE_PO_NUMBER', poNumber)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'REQUESTED_DELIVERY_DATE', requestedDeliveryDate, Regex.onlyNumeric)) {
    //   return false;
    // }
    if (!requestedDeliveryDate) {
      let msg = `${t('REQUESTED_DELIVERY_DATE_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }

    const now = dayjs();
    if (
      requestedDeliveryDate.isSame(now, 'day') ||
      requestedDeliveryDate.isBefore(now, 'day')
    ) {
      let msg = `${t('REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }

    if (!validateField(dispatch, 'PRIORITY', selectedPriority)) {
      return false;
    }
    // if (!validateField(dispatch, 'NOTE', note)) {
    //   return false;
    // }
    // if (!note) {
    //   let msg = `${t('NOTE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    return true;
  };

  async function createPayload(tempOrderList?: any[]) {
    // if (!checkValidity()) {
    //   return false;
    // }

    const now = dayjs();
    if (
      requestedDeliveryDate?.isSame(now, 'day') ||
      requestedDeliveryDate?.isBefore(now, 'day')
    ) {
      let msg = `${t('REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }

    let payload: any = {
      supplierName: _supplierState?.value?.supplierName,
      // ...(poNumber && { poNumber: Number.parseInt(poNumber) }),
      // ...(poNumber && { poNumber: poNumber }),
      poNumber: poNumber,
      // orderBy: orderBy,
      // requestedDeliveryDate: requestedDeliveryDate,
      // note: note,
      // totalAmount: totalPrice,
      // ...(orderBy && { orderBy: orderBy }),
      orderBy: orderBy,
      ...(requestedDeliveryDate && {
        requestedDeliveryDate: requestedDeliveryDate,
      }),
      ...(note && { note: note }),
      ...(totalPrice && { totalAmount: totalPrice }),
      //...(_draftOrders?.value?.data[0]?._id && { id: _draftOrders?.value?.data[0]?._id }),
      // priority: selectedPriority === 'Yes' ? true : false,
      priority:
        selectedPriority === 'Yes' || selectedPriority === 'Oui' ? true : false,
      products: ((tempOrderList !== undefined && tempOrderList?.length > 0) ||
      tempOrderList?.length === 0
        ? tempOrderList
        : ordersList
      ).map((item: any) => {
        return {
          categoryId: item?.categoryId,
          subCategoryId: item?.subCategoryId,
          productId: item?.productId,
          userProductId: item?.userProductId,
          product_id: item?.product_id,
          quantity: item?.quantity,
          price: item?.unitPrice,
          productName: item?.productName,
          totalPrice: item?.totalprice,
        };
      }),
    };
    return payload;
  }

  function dataPayload(payload: any) {
    if (payload?.products?.length > 0) {
      payload.products.forEach((product: any) => {
        delete product.productName;
        delete product.unitPrice;
        //delete product.totalPrice;
      });
    }

    if (payload?.id) {
      delete payload?.id;
    }

    return payload;
  }

  async function onSaveToCart() {
    // if (!checkValidity()) {
    //   return false;
    // }

    let payload = await createPayload();
    if (payload !== false) {
      let dataaPayload = await dataPayload(payload);
      let draftid;
      // let draftid = _draftOrders?.value?.data[0]?._id;
      const cartOrderId = id;
      const draftOrderId = _draftOrders?.value?.data[0]?._id;

      if (cartOrderId === draftOrderId) {
        draftid = draftOrderId;
      } else {
        if (draftOrderId) {
          await dispatch(deleteDraftOrderById({ id: draftOrderId }));
        }
        // await dispatch(deleteDraftOrderById({ id: draftOrderId }));
      }

      if (dataaPayload) {
        let newPayload = {
          ...payload,
          ...dataaPayload,
          ...(draftid && { id: draftid }),
        };

        if (isEdit) {
        } else {
          // if (!draftOrderId) {
          //   onSaveToCart();
          // } else if (draftOrderId === cartOrderId) {
          //   onSaveToCart();
          // } else {
          //   openSaveToCartConfirmDialog();
          // }
          if (payload?.products && payload?.products?.length > 0) {
            let response: any = await dispatch(draftorders(newPayload));
            await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
            if (response?.payload?.status === 200) {
              dispatch(clearCreateOrdersState());
              navigate(-1);
            }
          } else {
            dispatch(
              showErrorSnackbar({
                message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS'),
              })
            );
          }
        }
      }
    }
  }

  function setData(draftOrder: any) {
    try {
      if (draftOrder?._id) {
        setID(draftOrder?._id);
      }
      if (draftOrder?.orderBy) {
        setorderBy(draftOrder?.orderBy);
      }
      if (draftOrder?.poNumber) {
        setPoNumber(draftOrder?.poNumber);
      }
      //setRequestedDeliveryDate(dayjs(draftOrder?.requestedDeliveryDate || new Date()));
      setRequestedDeliveryDate(
        draftOrder?.requestedDeliveryDate
          ? dayjs(draftOrder?.requestedDeliveryDate)
          : null
      );

      if (draftOrder?.priority) {
        setSelectedPriority(draftOrder.priority === true ? 'Yes' : 'No');
      }
      if (draftOrder?.note) {
        setNote(draftOrder?.note);
      }
      const orders = draftOrder?.products.map((item: any) => {
        return {
          ...item,
          unitPrice: item?.price,
          totalprice: (Number(item?.quantity) * Number(item?.price)).toFixed(2),
          actions: [
            <BakeasyChipDelete
              onClick={(event) => {
                event.stopPropagation();
                openDeleteConfirmDialog(item?.productId);
              }}
            />,
          ],
        };
      });

      setOrdersList([...orders]);
    } catch (error) {}
  }

  function openCancelConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'delete',
      open: true,
      title: t('CONFIRMATION'),
      message: t('ORDER_CANCEL_CONFIRM_MESSAGE'),
      onNoClick: (event: any) => {},
      onYesClick: async (event: any, param: any | undefined) => {
        if (id !== undefined && id !== null && id !== '') {
          const payload: any = {
            id,
          };
          let response: any = await dispatch(deleteDraftOrderById(payload));
          // await refreshPageData(pageNo - 1);
          if (response?.error === null || response?.error === undefined) {
            dispatch(clearDraftOrdersState());

            // handleSaveToCartDialogClose();
            navigate(-1);
          }
        } else {
          navigate(-1);
        }
      },
    });
  }

  // const handleDeleteClick = async () => {
  //   if (selectedRows.length === 0) {
  //     // dispatch(showErrorSnackbar({ message: t('NO_PRODUCTS_ASSIGNMENT') }));
  //     return;
  //   }
  //   const payload = {
  //     // storeEntityId,
  //     assignment: 'delete',
  //     products: selectedRows.map((row: any) => ({ id: row._id }))
  //   };

  //   // await dispatch(deleteOrder(payload));
  //   // await refreshPageData(pageNo - 1);
  // };

  function handleClose() {
    myContext.setDialog({ open: false });
    // props?.onBack();
  }

  function openOkConfirmDialog() {
    myContext.setConfirmDialog({
      open: true,
      // type: 'YES',
      type: 'go-backToOrder',
      title: t('CONFIRMATION'),
      message: t('Do you want to save this order to cart?'),

      onYesClick: async (event: any, param: string | undefined) => {
        const cartOrderId = id;
        const draftOrderId = _draftOrders?.value?.data[0]?._id;
        if (!draftOrderId) {
          myContext.setConfirmDialog({ open: false });
          await onSaveToCart();
          handleClose();
        } else if (draftOrderId === cartOrderId) {
          myContext.setConfirmDialog({ open: false });
          await onSaveToCart();
          handleClose();
        } else {
          myContext.setConfirmDialog({ open: true });
          await openSaveToCartConfirmDialog();
          handleClose();
        }

        // myContext.setConfirmDialog({ open: true });
        // openSaveToCartConfirmDialog();
        // let payload = await createPayload();
        // if (payload !== false) {
        //   let dataaPayload = await dataPayload(payload);
        //   let draftid = _draftOrders?.value?.data[0]?._id;
        //   let newPayload = { ...payload, ...dataaPayload, ...(draftid && { id: draftid }) };
        //   await dispatch(draftorders(newPayload));
        //   dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
        //   navigate(-1);
        // }
      },
      onNoClick: () => {
        myContext.setConfirmDialog({ open: false });
      },
    });
  }

  async function openSaveToCartConfirmDialog() {
    myContext.setConfirmDialog({
      open: true,
      type: 'YES',
      title: t('CONFIRMATION'),
      message: t('ORDER_PRESENT_INCART'),
      onYesClick: async (event: any) => {
        await onSaveToCart();
      },
      onNoClick: () => {},
    });
  }

  async function autoSaveOrderToCart(olist: any[]) {
    // if (!checkValidity()) {
    //   return false;
    // }

    let payload = await createPayload(olist);
    if (payload !== false) {
      let dataaPayload = await dataPayload(payload);
      let draftid = _draftOrders?.value?.data[0]?._id;
      if (dataaPayload) {
        let newPayload = {
          ...payload,
          ...dataaPayload,
          ...(draftid && { id: draftid }),
        };

        if (isEdit) {
        } else {
          await dispatch(draftorders(newPayload));
          dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
        }
      }
    }
  }

  function getMenus() {
    return (
      <Grid>
        <div className="tableOptions">
          <Button.CancelDelete
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              openCancelConfirmDialog();
            }}
          />
          <Button.GoToOrderForm
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              openOkConfirmDialog();
            }}
          />
          {/* <Button.SaveToCart
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              // onSaveToCart();
              openSaveToCartConfirmDialog();
            }}
          /> */}

          <Button.SaveToCart
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              const cartOrderId = id;
              const draftOrderId = _draftOrders?.value?.data[0]?._id;

              if (!draftOrderId) {
                onSaveToCart();
              } else if (draftOrderId === cartOrderId) {
                onSaveToCart();
              } else {
                openSaveToCartConfirmDialog();
              }
            }}
          />

          <Button.Create
            onClick={async function (
              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
            ): Promise<void> {
              if (!checkValidity()) {
                return;
              }
              let payload = await createPayload();
              let extraPayload = id;
              let newPayload = { ...payload, ...(id && { id }) };

              openNewOrderSummaryDialog(false, newPayload);
            }}
          />
        </div>
      </Grid>
    );
  }

  function createOrderUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('ORDER_DETAILS')}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={getMenus()}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={'ORDER_DETAILS'} />
            </Grid>

            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  disabled={true}
                  label={t('SUPPLIER_NAME')}
                  value={_supplierState?.value?.supplierName ?? ''}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('ORDER_BY')}
                  type="text"
                  name=""
                  value={orderBy}
                  maxLength={10}
                  onChange={function (event: any): void {
                    setorderBy(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  // required={true}
                  label={t('STORE_PO_NUMBER')}
                  type="name"
                  placeHolder={t('ENTER_STORE_PO_NUMBER')}
                  value={poNumber}
                  maxLength={30}
                  onChange={(event: any) => {
                    setPoNumber(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('REQUESTED_DELIVERY_DATE')}
                  disabled={false}
                  value={requestedDeliveryDate}
                  // minDate={dayjs(new Date()).add(-1, 'days')}
                  minDate={dayjs(new Date())}
                  onChange={(e) => setRequestedDeliveryDate(dayjs(new Date(e)))}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.YesNo
                  label={'HIGH_PRIORITY'}
                  value={selectedPriority}
                  onChange={(event: any) => {
                    setSelectedPriority(event?.target?.value);
                  }}
                  placeholder={t('SELECT_HIGH_PRIORITY')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('NOTE')}
                  placeHolder={t('ENTER_NOTE')}
                  type="text"
                  name="description"
                  value={note}
                  multiline
                  rows={2}
                  onChange={(event: any) => {
                    setNote(event.target.value);
                  }}
                  required={false}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h2" sx={{ fontWeight: '600' }}>
                {t('ADD_PRODUCTS')}
              </Typography>
            </Grid>
            <Grid container spacing={2} ml={2} mt={0}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <BakeasyAutoCompleteCategoryA
                  value={selectedCategory}
                  options={_categoryState.value?.data}
                  onChange={(newValue: any) => {
                    if (typeof newValue === 'string' && newValue?.length > 2) {
                      dispatch(
                        fetchCategories({
                          page: 1,
                          limit: 10,
                          search: newValue,
                        })
                      );
                    }

                    if (newValue === null || newValue?.length === 0) {
                      dispatch(fetchCategories({ page: 1, limit: 10 }));
                      setSelectedCategory(undefined);
                      dispatch(clearSubCategoryState());
                    }

                    if (typeof newValue === 'object') {
                      handleCategorySelect(newValue);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <BakeasyAutoCompleteSubCategoryA
                  value={selectedSubCategory}
                  options={_subCategoryState.value?.data}
                  onChange={async (newValue: any) => {
                    if (newValue === null || newValue?.length === 0) {
                      setSelectedSubCategory(undefined);

                      await dispatch(
                        fetchProducts({
                          page: 1,
                          limit: 10,
                          ...(selectedCategory?._id && {
                            categoryId: selectedCategory?._id,
                          }),
                        })
                      );
                    }

                    if (typeof newValue === 'object') {
                      handleSubCategorySelect(newValue);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <BakeasyAutoCompleteProduct
                  value={selectedProduct}
                  options={_productsState.value?.data}
                  onChange={async (newValue: any) => {
                    if (typeof newValue === 'string' && newValue?.length > 2) {
                      dispatch(clearProductState());
                      await dispatch(
                        fetchProducts({
                          page: 1,
                          limit: 10,
                          ...(selectedCategory?._id && {
                            categoryId: selectedCategory?._id,
                          }),
                          ...(selectedSubCategory?._id && {
                            subCategoryId: selectedSubCategory?._id,
                          }),
                        })
                      );
                    }

                    if (newValue === null || newValue?.length === 0) {
                      dispatch(clearProductState());
                      await dispatch(
                        fetchProducts({
                          page: 1,
                          limit: 10,
                          ...(selectedCategory?._id && {
                            categoryId: selectedCategory?._id,
                          }),
                          ...(selectedSubCategory?._id && {
                            subCategoryId: selectedSubCategory?._id,
                          }),
                        })
                      );
                    }

                    if (typeof newValue === 'object') {
                      handleProductSelect(newValue);
                    }
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<Category
									disabled={false}
									label={t("CATEGORY")}
									size={"small"}
									placeholder={t("SELECT_CATEGORY")}
									fullWidth={true}
									value={selectedCategory}
									options={catData?.data}
									onChange={(event: SelectChangeEvent<HTMLSelectElement>) => {
										handleCategorySelect(event?.target?.value);
									}}
									statusOptions={[]}
								/>
							</Grid> */}
              {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<SubCategory
									disabled={false}
									fullWidth={true}
									size={"small"}
									label={t("SUB_CATEGORY")}
									placeholder={t("SELECT_SUBCATEGORY")}
									value={selectedSubCategory}
									options={subcatData?.data}
									onChange={(event: SelectChangeEvent<HTMLSelectElement>) => {
										setSelectedSubCategory(event.target.value);
									}}
									statusOptions={[]}
								/>
							</Grid> */}
              {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<BakeasySelectProduct
									fullWidth={true}
									size={"small"}
									label={t("PRODUCT_NAME")}
									placeholder={t("PRODUCT_NAME")}
									value={productName}
									options={productdata?.data}
									onChange={(e: any) => setProductName(e.target.value)}
									statusOptions={[]}
								/>
							</Grid> */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <BakeasyTextField
                  label={t('STORE_COST') + getCurrency(_storeState?.value)}
                  placeHolder={t('ENTER_STORE_COST')}
                  type="number"
                  name=""
                  required={true}
                  disabled={true}
                  value={price}
                  maxLength={10}
                  onChange={(event: any) => {
                    setPrice(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                {/* <TextField.Quantity
                  type="number"
                  value={quantity}
                  maxLength={5}
                  onChange={(e: any) => setQuantity(e.target.value)}
                /> */}
                <BakeasyTextField
                  label={t('QUANTITY')}
                  type="text"
                  placeHolder={''}
                  name="quantity"
                  required={true}
                  value={quantity}
                  maxLength={4}
                  regexPattern={Regex.quantity}
                  onChange={(event: any) => {
                    const newValue = event.target.value;
                    const formattedValue =
                      newValue.length > 0
                        ? newValue.startsWith('0') && newValue !== '0'
                          ? newValue.slice(1)
                          : newValue
                        : '0';
                    setQuantity(formattedValue);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: 1,
            }}
          >
            <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
              <Grid>
                <Button.Clear onClick={handleClearForm} />
              </Grid>
              <Grid>
                {/* <Button.Add onClick={handleAddButtonClick} /> */}

                <Button.Add
                  onClick={() => {
                    // if (!validateField(dispatch, 'QUANTITY', quantity, Regex.quantity)) {
                    //   return;
                    // }
                    // if (Number(quantity) <= 0 || Number(price) <= 0) {
                    //   dispatch(
                    //     showErrorSnackbar({ message: 'Quantity and Price must be greater than 0.' })
                    //   );
                    //   return;
                    // }
                    const sameProduct = ordersList.some(
                      (product) =>
                        product?.productName?.toLowerCase() ===
                        selectedProduct?.productName?.toLowerCase()
                    );

                    if (sameProduct) {
                      dispatch(
                        showErrorSnackbar({
                          message: t('THIS_PRODUCT_IS_ALREADY_ADDED'),
                        })
                      );
                      return;
                    }
                    handleAddButtonClick();
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid sx={{ p: 2 }}>
            {ordersList?.length > 0 && (
              <BakeasySimpleTable
                type="createOrder"
                headers={createOrderProductTableHeaders}
                tableData={ordersList}
                openDeleteConfirmDialog={openDeleteConfirmDialog}
              />
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return createOrderUI();
};
